"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIFS = void 0;
const tab_1 = require("../../../tab");
exports.MINIFS = {
    description: 'Select the minimum value of the selected min_range that meet the specified criteria(s), multiple conditions are evaluated as AND',
    arg_names: ['min_range', 'criteria', 'next_criterias'],
    args_def: [
        {
            types: ['range_reference'],
            required: true,
        },
        {
            types: ['boolean'],
            required: true,
        },
        {
            types: ['boolean'],
            required: false,
            variadic: true,
        },
    ],
    args_description: ['column to minimize', 'criteria', 'other criteria'],
    special_fn_type: 'aggregation',
    return_type: tab_1.ColumnType.NUMBER || tab_1.ColumnType.STRING || tab_1.ColumnType.DATE,
};
